import apiTrainings from '@/api/trainings'

const state = {
  error: null,
  isSubmitting: false
}

export const mutationTypes = {
  deleteTrainingStart: '[delete training] Delete training start',
  deleteTrainingSuccess: '[delete training] Delete training success',
  deleteTrainingFailure: '[delete training] Delete training failure'
}

export const actionTypes = {
  deleteTraining: '[delete training] Delete training'
}

const mutations = {
  [mutationTypes.deleteTrainingStart](state) {
    state.isSubmitting = true
  },

  [mutationTypes.deleteTrainingSuccess](state) {
    state.isSubmitting = false
  },

  [mutationTypes.deleteTrainingFailure](state, payload) {
    state.error = payload
    state.isSubmitting = false
  }
}

const actions = {
  [actionTypes.deleteTraining](context, {id}) {
    context.commit(mutationTypes.deleteTrainingStart)
    return new Promise(resolve => {
      apiTrainings
        .deleteTraining(id)
        .then(response => {
          context.commit(mutationTypes.deleteTrainingSuccess)
          resolve(response.data)
        })
        .catch(resolve => {
          context.commit(
            mutationTypes.deleteTrainingFailure,
            resolve.response.data.errors
          )
        })
    })
  }
}

export default {
  state,
  mutations,
  actions
}
